<template>
    <!-- Arborescence -->
    <HeritageTree :Variant="Variant" :FilterTreeStore="filterTreeStore" :ShowToolbar="true" :ShowSearchButton="true"
        :IsDraggable="featurePath === $store.getters['GetObjectDisplayingFeaturePath'] && $store.getters['CheckAction']('Write', 'ObjectSheet')" v-on="$listeners" >
        <template v-slot:ToolBarBeforeSearch>
            <!-- bouton de création de noeud root-->
            <!-- Options -> Options-->
            <b-button v-if="!InGrouping && (featurePath === $store.getters['GetObjectDisplayingFeaturePath'] && $store.getters['CheckAction']('Write', 'ObjectSheet'))  && !hasRestrictedPerimeter"
                @click="displayMenu($event);" v-b-tooltip.noninteractive.hover :title="$t('Options')" variant="outline-dark" class="btn-circle border-0 p-0">
                <b-icon icon="diagram-2" font-scale="1.5" />
            </b-button>
        </template>
    </HeritageTree>
</template>

<script lang="ts">
    import Component from 'vue-class-component';
    import { Inject, InjectReactive, Prop } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';
    import HeritageTree from '@/components/commons/HeritageTree.vue';
    import { MAIN_FILTER_TREE } from '@/App.settings';
    import { ObjectUtils } from '@/components/commons/Utils';
    import locales from './locales/FullSidebar.json'
import { NavigationMediator } from '@/mediators/NavigationMediator';

    /** Sidebar contenant l'arborescence ou la liste des fonctions */
    @Component({
        components: {
            HeritageTree
        },
        i18n : {messages: locales}
    })
    export default class FullSidebar extends ObjectUtils {
        /** Nom store Vuex à passer à HeritageTree. Variable nécessaire pour utilisation dans la section Template */
        protected filterTreeStore = MAIN_FILTER_TREE;

        /** Variant de couleur à appliquer sur le composant */
        @InjectReactive()
        public Variant!: string;
        /** Chemin de la fonction courante */
        @Getter('GetFeaturePath')
        private featurePath!: string;

        /** Information si utilisateur superviseur */
        @Getter('SessionStore/GetHasRestrictedPerimeter')
        private hasRestrictedPerimeter!: boolean;

        /** Indique la fenêtre de gestion des regroupements est affichée ou non */
        @Prop()
        public InGrouping!: boolean;

        /** Fonction emettant un évènement pour réduire la sidebar */
        private toggleSidebarCollapsed() {
            this.$emit('ToggleSidebarCollapsedEvent');
        }

        /** 
         * Informe le Workbench d'afficher le menu contextuel
         * @param e Events
         *  */
        private displayMenu(e) {
            /** @todo Fabien. Positionner le menu en-dessous du bouton */
            this.$emit('DisplayContextMenuEvent', e, e.pageX, e.pageY + 10, this.$store.getters[this.filterTreeStore + '/RootNode']);
        }

        @Inject()
		protected navigationMediator: NavigationMediator;
    }
</script>

<style scoped>
</style>